import { useEffect, useState } from 'react';
import { useQuery } from 'react-query'
import { useNavigate, useParams } from 'react-router-dom';
import { useTheme } from '../../../contexts/ThemeContext'
import { ToastContainer } from 'react-toastify';
import dataCalls from '../../../shared/dataCalls';
import staticData from '../../../shared/staticData';
import BackButton from '../../../components/BackButton';
import utils from '../../../shared/utils';
import Skeleton from 'react-loading-skeleton';
import PreviewButtons from '../Shared/Buttons/PreviewButtons';

export default function Preview() {

    const [ isLoadingIframe, setIsLoadingIframe ] = useState(true);
    const iFrameStyle = !isLoadingIframe ? {} : {visibility: 'hidden'};
    const onIFrameLoad = (e) => {
        setIsLoadingIframe(false);
        utils.onIframeLoad(e, "SuperRebalancerPreviewContent", 1.01);
    }

    const params = useParams();

    const { data, isLoading } = useQuery('superRebalancerPreviewHtml', () => dataCalls.fetchReportViewModel(params.id), {
        refetchOnMount: true,
        refetchOnReconnect: false,
        refetchOnWindowFocus: false
    });

    const { setBackgroundClass, setJustifyClass, resetTheme } = useTheme();
    useEffect(() => {
        setBackgroundClass("bg-gray");
        setJustifyClass("");
        return () => resetTheme();
    }, []);

    useEffect(() => {
        window.scrollTo({top: 0, left: 0 });
    }, []);

    const navigate = useNavigate();
    const backToEditMethod = () => {
        navigate(`/v1/reports/superrebalancer/edit/${params.id}`);
    }

    return (
        <div className="justify-center place-content-center w-3/4 mt-6 min-h-full h-full">
            <div className="grid grid-cols-4">
                <div className="block col-span-3">
                    <BackButton text="Back to Report Builder" onClick={backToEditMethod} />
                    {isLoading
                        ? <h2><Skeleton /></h2>
                        : <h2>Super Rebalancer Report for {data?.names}</h2>
                    }
                </div>
                <div className="w-full flex justify-end items-center pr-4">
                    <img alt="Super Rebalancer Logo" src={staticData.getReport(7).imgSrc} className="w-16 h-16"></img>
                </div>
            </div>
            <div className="flex justify-start mt-6 mb-2">
                <h3>Report Preview</h3>
            </div>
            
            {isLoadingIframe && <Skeleton height={utils.getWindowDimensions().height * 0.7} />} 
            <div className="flex w-full flex-col">
                <iframe
                    title="Super Rebalancer Report Preview" 
                    style={iFrameStyle}
                    src={`/api/reports/superrebalancer/preview?id=${params.id}`}
                    onLoad={(onIFrameLoad)}
                />
            </div>

            <PreviewButtons reportId={Number(params.id)} reportType={7} backToEditMethod={backToEditMethod} showBackToEditButton={false} />
            <ToastContainer />
        </div>
    )
}
